var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8505 13.9075C19.4037 13.5211 1.21201 0.708332 0.382206 0.193235L0.126953 0V3.15489C0.126953 4.18509 0.637526 4.50702 1.27585 5.02212L1.40351 5.08658C2.29715 5.73046 15.2548 14.8089 16.9782 16.0322C15.2548 17.2556 2.10563 26.4628 1.27585 26.9779C0.254542 27.6217 0.190711 28.0725 0.190711 28.9739V32C0.190711 32 19.5314 18.4145 19.9144 18.0926C20.808 17.4487 20.9995 16.6117 20.9995 16.0966V15.7103C20.9995 15.0664 20.6165 14.4226 19.8505 13.9075V13.9075Z",
    fill: "#356AE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48945 17.4494C9.00008 17.4494 9.51076 17.2562 10.0214 16.87C10.6597 16.4193 11.2341 16.033 11.2341 16.033L11.4257 15.9042L11.2341 15.7755C11.1702 15.711 2.68085 9.78755 1.78721 9.20808C1.40423 8.88616 0.893584 8.82175 0.574411 9.01485C0.255262 9.20807 0 9.52995 0 10.045V12.041L0.0639052 12.1055C0.127836 12.17 5.93628 16.2262 7.08523 16.9988C7.59588 17.3208 8.04271 17.4496 8.48953 17.4496L8.48945 17.4494Z",
    fill: "#356AE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCampaignIcon);
export default __webpack_public_path__ + "static/media/active_campaign_icon.437c574b.svg";
export { ForwardRef as ReactComponent };